// extracted by mini-css-extract-plugin
module.exports = {"ModalWrapper":"deliveryModal_ModalWrapper__2fZJw","gridWrapper":"deliveryModal_gridWrapper__1pAwi","DropDownsWrapper":"deliveryModal_DropDownsWrapper__s5F8B"};